// import React, { useState } from "react";
// import { login, getCurrentUser } from "../services/authService";
// import { useNavigate } from "react-router-dom";

// export default function Login() {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await login(username, password);
//       // optional: getCurrentUser()
//       navigate("/"); // go to home or dashboard
//     } catch (err) {
//       setError(err.response?.data || "Login failed");
//     }
//   };

//   return (
//     <div className="p-6 max-w-md mx-auto">
//       <h2 className="text-2xl font-bold mb-4">Login</h2>
//       {error && <div className="text-red-600 mb-2">{error}</div>}
//       <form onSubmit={handleSubmit} className="flex flex-col gap-3">
//         <input required value={username} onChange={e=>setUsername(e.target.value)} placeholder="Username" className="border p-2 rounded"/>
//         <input required type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="Password" className="border p-2 rounded"/>
//         <button className="bg-blue-600 text-white p-2 rounded">Login</button>
//       </form>
//     </div>
//   );
// }

// import { useState } from "react";
// import { loginUser } from "../services/authService";
// import { useNavigate } from "react-router-dom";

// export default function Login() {
//   const [email, setEmail] = useState("");
//   const [pwd, setPwd] = useState("");
//   const [error, setError] = useState("");
//   const nav = useNavigate();

//   const submit = async (e) => {
//     e.preventDefault();
//     try {
//       await loginUser(email, pwd);
//       nav("/");
//     } catch (err) {
//       setError(err.response?.data || "Login failed");
//     }
//   };

//   return (
//     <div className="p-6 max-w-md mx-auto">
//       <h2 className="text-2xl mb-4">User Login</h2>
//       {error && <p className="text-red-600">{error}</p>}

//       <form onSubmit={submit} className="flex flex-col gap-3">
//         <input
//           className="border p-2"
//           placeholder="Email"
//           onChange={(e) => setEmail(e.target.value)}
//         />
//         <input
//           className="border p-2"
//           placeholder="Password"
//           type="password"
//           onChange={(e) => setPwd(e.target.value)}
//         />
//         <button className="bg-blue-600 text-white p-2">Login</button>
//       </form>
//     </div>
//   );
// }
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import AuthService from "../services/authService";

// export default function Login() {
//   const navigate = useNavigate();
//   const [form, setForm] = useState({ email: "", password: "" });

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleLogin = (e) => {
//     e.preventDefault();

//     const result = AuthService.loginUser(form.email, form.password);

//     if (!result.success) {
//       alert(result.message);
//       return;
//     }

//     alert("Login successful!");
//     navigate("/booking");
//   };

//   return (
//     <div className="login-container">
//       <form className="login-card" onSubmit={handleLogin}>
//         <h2>User Login</h2>

//         <input
//           type="email"
//           name="email"
//           placeholder="Email Address"
//           value={form.email}
//           onChange={handleChange}
//           required
//         />

//         <input
//           type="password"
//           name="password"
//           placeholder="Password"
//           value={form.password}
//           onChange={handleChange}
//           required
//         />

//         <button type="submit">Login</button>

//         <p>
//           Don’t have an account?{" "}
//           <span onClick={() => navigate("/register")}>Register</span>
//         </p>
//       </form>
//     </div>
//   );
// }


// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// export default function Login() {
//   const navigate = useNavigate();
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");

//   const handleLogin = async (e) => {
//     e.preventDefault();

//     try {
//       const response = await axios.post(
//         "http://localhost:8080/api/auth/login",
//         { email, password }
//       );

//       const user = response.data;

//       if (!user || !user.id) {
//         alert("Invalid login!");
//         return;
//       }

//       // Save user details
//       localStorage.setItem("user", JSON.stringify(user));  // USED BY ADMIN ALSO
//       localStorage.setItem("userId", user.id);              // ⭐ ADDED FOR BOOKING ONLY
//       localStorage.setItem("isLoggedIn", "true");           // OPTIONAL & SAFE

//       alert("Login Successful!");

//       // Redirect based on role (ADMIN / USER)
//       if (user.role.toUpperCase() === "ADMIN") {
//         navigate("/admin/manage-rooms");     // ⭐ ADMIN STILL WORKS
//       } else {
//         navigate("/");                       // USER HOME
//       }

//     } catch (error) {
//       console.error("Login Error:", error);
//       alert("Login failed! Check backend.");
//     }
//   };

//   return (
//     <div className="login-container">
//       <form className="login-card" onSubmit={handleLogin}>
//         <h2>User Login</h2>

//         <input
//           type="email"
//           placeholder="Enter email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           required
//         />

//         <input
//           type="password"
//           placeholder="Enter password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           required
//         />

//         <button type="submit">Login</button>

//         <p>
//           Don't have an account?{" "}
//           <span onClick={() => navigate("/register")}>Register</span>
//         </p>
//       </form>
//     </div>
//   );
// }

//*******LOGIN DESIGN CODE ********//5/1/26

// import React, { useState } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import axios from "axios";

// export default function Login() {
//   const navigate = useNavigate();

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");

//   const handleLogin = async (e) => {
//     e.preventDefault();

//     try {
//       const response = await axios.post(
//         "http://localhost:8080/api/auth/login",
//         { email, password }
//       );

//       const user = response.data;

//       localStorage.setItem("user", JSON.stringify(user));
//       localStorage.setItem("isLoggedIn", "true");

//       alert("Login Successful!");

//       if (user.role === "ADMIN") {
//         navigate("/admin/manage-rooms");
//       } else {
//         navigate("/");
//       }
//     } catch (error) {
//       console.error("Login Error:", error);
//       alert(error.response?.data || "Invalid email or password");
//     }
//   };

//   return (
//     <div className="container d-flex justify-content-center align-items-center vh-100">
//       <div className="card shadow-lg border-0 p-4" style={{ width: "400px" }}>
//         <h3 className="text-center fw-bold mb-2">🔐 User Login</h3>
//         <p className="text-center text-muted mb-4">
//           Login to continue booking
//         </p>

//         <form onSubmit={handleLogin}>
//           <div className="mb-3">
//             <label className="form-label fw-semibold">Email</label>
//             <input
//               type="email"
//               className="form-control"
//               placeholder="Enter email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//             />
//           </div>

//           <div className="mb-3">
//             <label className="form-label fw-semibold">Password</label>
//             <input
//               type="password"
//               className="form-control"
//               placeholder="Enter password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//             />
//           </div>

//           <button className="btn btn-primary w-100 fw-bold mt-2">
//             Login
//           </button>
//         </form>

//         <div className="text-center mt-3">
//           <small>
//             Don&apos;t have an account?{" "}
//             <Link to="/register" className="fw-semibold text-primary">
//               Register
//             </Link>
//           </small>
//         </div>
//       </div>
//     </div>
//   );
// }


/*******9/1/26****** */
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { useState } from "react";

// export default function Login() {
//   const navigate = useNavigate();
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");

//   const handleLogin = async (e) => {
//     e.preventDefault();

//     try {
//       const res = await axios.post("http://localhost:8080/api/auth/login", {
//         email,
//         password
//       });

//       // ✅ STORE USER IN localStorage
//       localStorage.setItem("user", JSON.stringify(res.data));
      

//       // ✅ REDIRECT BASED ON ROLE
//       if (res.data.role === "ADMIN") {
//         navigate("/admin/dashboard", { replace: true });
// } else {
//   navigate("/", { replace: true });
//       }

//     } catch (err) {
//       alert("Invalid email or password");
//     }
//   };

//   return (
//     <form onSubmit={handleLogin}>
//       <input onChange={e => setEmail(e.target.value)} placeholder="Email" />
//       <input type="password" onChange={e => setPassword(e.target.value)} placeholder="Password" />
//       <button type="submit">Login</button>
//     </form>
//   );
// }


//****17/1/26****//

import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { useState } from "react";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post("http://localhost:8080/api/auth/login", {
        email,
        password,
      });

      localStorage.setItem("user", JSON.stringify(res.data));

      if (res.data.role === "ADMIN") {
        navigate("/admin/dashboard", { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    } catch (err) {
      alert("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh", background: "#f5f7fa" }}
    >
      <div className="card shadow p-4" style={{ width: "100%", maxWidth: "420px" }}>
        <div className="text-center mb-4">
          <h3 className="fw-bold">🔐 Login</h3>
          <p className="text-muted">Welcome back! Please sign in</p>
        </div>

        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <div className="text-center mt-3">
          <span className="text-muted">Don’t have an account?</span>{" "}
          <Link to="/register">Register</Link>
        </div>
      </div>
    </div>
  );
}

